// Central React Query keys for the matches family. All matches queries share
// the ['matches', …] prefix so a single invalidateQueries({ queryKey: ['matches'] })
// (or setQueriesData) reaches every variant — the evaluated infinite list, the
// CVPicker selected set, and the Apps dashboard slice. Defining them here keeps
// the prefix consistent and avoids the typo'd-key invalidation footguns we've
// hit before (see the matches-pending prefix bug in Matches.tsx history).

export const MATCHES_PREFIX = ['matches'] as const;

export interface MatchesListParams {
  fit?: string;
  sort?: string;
  q?: string;
  remote?: boolean;
}

export const queryKeys = {
  // Prefix that catches every matches query for bulk invalidation.
  matchesAll: MATCHES_PREFIX,
  // The Evaluated tab's paginated/searched list (useInfiniteQuery).
  matchesList: (params: MatchesListParams) => ['matches', params] as const,
  // CVPicker's "selected for CV" pool.
  matchesSelected: () => ['matches', { selected: true }] as const,
  // Pending inbox (count + list share this prefix).
  matchesPending: ['matches-pending'] as const,
  matchesPendingCount: ['matches-pending-count'] as const,
  cvSelections: ['cv-selections'] as const,
  cvTailored: ['cv-tailored'] as const,
};
